import { Component } from 'preact';
import { getDateTimeFormatConverter } from '../../utils/formatters';
import handleLoadingAndError from '../handle-loading-and-error';
import Table from '../table';
import style from './style.scss';
import CardDateLabel from '../card-date-label';

/**
 * The SunMoonInfo component displays basic sun and moon information -
 * sunrise and set, moonrise and set, moon phase.
 *
 * props:
 * - data: `sunMoon` sub-object from the full live data api response.
 */
class SunMoonInfo extends Component {

	constructor(props) {
		super(props);
		this.timeFormatter = getDateTimeFormatConverter('%H:%M', '%-I:%M %p');
		this.dateFormatter = getDateTimeFormatConverter('%Y-%m-%d', '%-d %B');
	}

	render(props) {
		const date = this.dateFormatter(props.data.date);

		const validRegex = /^[0-9]{2}:[0-9]{2}$/;

		const moonrise = validRegex.test(props.data.moonrise)
			? this.timeFormatter(props.data.moonrise)
			: '---';

		const moonset = validRegex.test(props.data.moonset)
			? this.timeFormatter(props.data.moonset)
			: '---';

		return (
			<div class={style.sun_moon}>
				<CardDateLabel date={date} />
				<Table>
					<tbody>
					<tr>
						<td>Sunrise</td>
						<td>{ this.timeFormatter(props.data.sunrise) }</td>
					</tr>
					<tr>
						<td>Sunset</td>
						<td>{ this.timeFormatter(props.data.sunset) }</td>
					</tr>
					<tr>
						<td>Moonrise</td>
						<td>{ moonrise }</td>
					</tr>
					<tr>
						<td>Moonset</td>
						<td>{ moonset }</td>
					</tr>
					<tr>
						<td>Moon Phase</td>
						<td>{ props.data.moonPhase }</td>
					</tr>
					</tbody>
				</Table>
			</div>
		);
	}

}

export default handleLoadingAndError(SunMoonInfo);



// WEBPACK FOOTER //
// ./components/sun-moon-info/index.js